import { createContext } from 'react';

type FinixEnvironment = 'sandbox' | 'live';

interface FinixEnvironmentContextType {
  environment: FinixEnvironment;
  setEnvironment: (environment: FinixEnvironment) => void;
}

export const FinixEnvironmentContext =
  createContext<FinixEnvironmentContextType>({
    environment:
      (import.meta.env.VITE_FINIX_DEFAULT_ENVIRONMENT as FinixEnvironment) ??
      'sandbox',
    setEnvironment: () => {},
  });
